import {useState, useEffect} from "react";
import Navbar from "./Navbar";
import {Outlet, useLocation} from "react-router-dom";
import Sidebar from "./Sidebar";

export default function ProtectedLayout() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();

    useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

    return (
        <>
            <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            {sidebarOpen && (
                <div className="sidebar-backdrop" onClick={() => setSidebarOpen(false)} />
            )}
            <div className="main-wrapper">
                <Navbar onMenuClick={() => setSidebarOpen(o => !o)} />
                <div className="page-content">
                    <Outlet />
                </div>
            </div>
        </>
    );
}
